import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/home/welcome_bonus';
import PurpleButton from '../../../components/purple-button';
import PromotionsUtil from '../../../../utils/promotions';
import ModalsLib from '../../../../lib/modals';
import Timer from './timer';

export default () => {
    const {isAuth, active, timestamp} = useSelector(Selector);

    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster promotion-modal promotion-welcome">
            <div className="modal-header">
                <div className="close" onClick={e => {
                    PromotionsUtil.closePromotionModal('promotions-welcome');
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="layer"><div className="gift"></div></div>
                <div className="layer"><div className="gift"></div></div>
                <div className="layer"><div className="girl"></div></div>
                <div className="layer">
                    <div className="content center">
                        <div className="top">
                            <div className="title">Make deposit<br/>and get<br/>up to <span>$6,000</span></div>
                            <div className="descriptions">You have a <b>welcome</b> bonus of <b>+50% on your first deposit</b>.</div>
                        </div>
                        <div className="center">
                            <Timer timestamp={timestamp} />
                        </div>
                        <div className="bottom">
                            <PurpleButton onClick={e => {
                                PromotionsUtil.clickPromotionModals('promotions-welcome', () => {
                                    ModalsLib.open('wallet');
                                });
                            }}>Deposit</PurpleButton>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}